<template>
  <div :style="tamanho ? `width: ${tamanho}px; height: ${tamanho}px;` : ''" class="container-simples">
    <div :class="['circulo', `${classe}-simples`]"></div>
    <div class="circulo-sombra"></div>
  </div>
</template>

<script>
export default {
  name: "Simples",
  props: {
    tamanho: String,
    classe: String
  }
};
</script>

<style lang="scss" scoped>
@keyframes rotateSimples {
  0% {
    rotate: 0deg;
  }
  100% {
    rotate: 360deg;
  }
}
.container-simples {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  position: relative;
  // background: red;
}
.circulo {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 1px solid var(--cinza02);
}
.circulo-sombra {
  height: calc(100% - 2px);
  width: calc(100% - 2px);
  border-radius: 50%;
  left: 1px;
  top: 1px;
  box-shadow: 1px 1px 1px 0 white;
  position: absolute;
  animation: rotateSimples 1s infinite linear;
}
.preferencia_tarifaria-simples,
.class_importacao-simples {
  border: 1px solid var(--importacao);
}

.pis_cofins-simples,
.cide_combustivel-simples {
  border: 1px solid var(--pis-cofins);
}

.icms_interno-simples,
.icms_st-simples,
.carga_liquida-simples,
.antecipacao-simples,
.difal-simples {
  border: 1px solid var(--icms);
}

.ipi-simples {
  border: 1px solid var(--ipi);
}
.verde-simples {
  border: 1px solid var(--verde2);
}
.vermelho-simples {
  border: 1px solid var(--vermelho2);
}
.azul-simples {
  border: 1px solid var(--azul2);
}

</style>
